<template>
  <div class="cleanup-progress-dialog-box">
    <el-dialog
      :title="$t('wrh-dashboard.cleanup-progress-dialog-box.title')"
      @close="onClose"
      show-close
      visible>

      <div class="mx-24 my-24 el-text el-text--size-xs">
        <div style="margin-top: 13px; margin-bottom: -4px;">
          {{ $t('wrh-dashboard.cleanup-progress-dialog-box.message') }}

          <el-progress
            class="mt-24 mb-8"
            :percentage="getCleanupProgressPercent"
            size="small"/>

          <span
            v-if="isCleanupBoxNameVisible"
            class="cleanup-lighter-text">
            {{ $t('wrh-dashboard.cleanup-progress-dialog-box.status',
                  {displayName: getCleanupBoxName})
            }}
          </span>
        </div>
      </div>

      <template #footer>
        <el-button
          @click="onClose"
          native-type="button"
          type="secondary">
          {{ $t('wrh-dashboard.form.button.close') }}
        </el-button>

      </template>
    </el-dialog>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import {
  START_CLEANUP_PROGRESS_POLLING,
  STOP_CLEANUP_PROGRESS_POLLING
} from '../store/action-types';

const { mapGetters, mapActions } = createNamespacedHelpers('wrh-dashboard');

export default {
  name: 'CleanupProgressDialogBox',
  computed: {
    ...mapGetters([
      'getCleanupBoxName',
      'getCleanupProgressPercent'
    ]),
    isCleanupBoxNameVisible() {
      return this.getCleanupBoxName !== '';
    }
  },
  methods: {
    ...mapActions({
      startCleanupProgressPolling: START_CLEANUP_PROGRESS_POLLING,
      stopCleanupProgressPolling: STOP_CLEANUP_PROGRESS_POLLING
    }),
    onClose() {
      this.stopCleanupProgressPolling();
      this.$emit('handleClose');
    }
  },
  mounted() {
    this.startCleanupProgressPolling();
  },
  beforeDestroy() {
    this.stopCleanupProgressPolling();
  }
};
</script>

<style lang="scss" scoped>
  .cleanup-lighter-text {
    color: $av-fixed-lighter;
  }
</style>
